export default __webpack_public_path__ + "static/media/f3ce7a0ce7d758df2edef66fb369bd87.svg";